<template>
  <vs-popup class="customer-sample-order-create-popup" id="popup" title="RM BATCH DETAILS VIEW/UPDATE"
    @close="open = false" :active.sync="open" :buttons-hidden="true">
    <vx-card no-shadow>
      <div class="vx-row mb-3">
        <div class="vx-col w-full">
          <small class="label">Invoice Number</small>
          <vs-input v-model="batch_details.invoice_number" name="invoice_number" class="w-full required" label=""
            val-icon-danger="icon-x" val-icon-pack="feather" />
        </div>
      </div>
      <div class="vx-row mb-3">
        <div class="vx-col w-full">
          <small class="label">RM Batch Notes</small>
          <vs-textarea class="mb-0" v-model="batch_details.note" height="70px" />
        </div>
      </div>

      <div class="flex flex-wrap items-center justify-end mt-8">
        <vs-button @click="onClickSave()" button="submit" color="primary" class="ml-auto mt-2">Save Changes</vs-button>
      </div>

    </vx-card>
  </vs-popup>
</template>

<script>
 import {RepositoryFactory} from '@/repository/RepositoryFactory'
const InventoryRepository = RepositoryFactory.get('inventory');

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

function initialState() {
  return {
    open: false,
    id: '',
    file: '',
    batch_details: {
      invoice_number: '',
      note: ''
    }
  }
}

export default {
  name: 'RmOrderItemBatchUpdatePopUp',
  data() {
    return initialState()
  },
  methods: {
    async onClickDownload() {
      window.open(this.file);
    },
    async openPopup(batch_details) {
      try {
        await Object.assign(this.$data, initialState())
        Object.assign(this.batch_details, batch_details)
        this.open = true
      } catch (error) {
        this.convertAndNotifyError(error);
      }
    },
    async onClickSave() {
      try {
        await InventoryRepository.updateRamItemBatchDetails(this.batch_details.id, { 
          invoice_number: this.batch_details.invoice_number,
          note: this.batch_details.note
         })
         this.showSuccessMessage('RM batch details updated successfully')
         this.$emit('refreshData')
         this.open = false
      } catch (error) {
        this.convertAndNotifyError(error)
      }
    }
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
.customer-sample-order-create-popup>>>.vs-popup {
  /*min-height: 78% !important;*/
  min-width: 20% !important;
}
</style>
